declare global {
  interface Window {
    infopidAuth?: (token: string) => void;
    infopidSignout?: () => void;
  }
}

export const useInfopid = () => {
  const isLoaded = ref(false);
  const { load } = useScript('/js/infopid.js', {
    trigger: 'manual',
  });

  const { user } = useAuth();
  const { generateToken } = useGenerateToken();

  const startInfopid = async () => {
    try {
      if (import.meta.server) {
        return;
      }
      const phone = user.value?.phoneNumber;
      const token = await generateToken(phone);
      if (!isLoaded.value) {
        await load();
        isLoaded.value = true;
      }
      window.infopidAuth?.(token);
    } catch (e) {
      console.log((e as Error).message);
    }
  };

  const clearInfopid = () => {
    window.infopidSignout?.();
  };
  if (import.meta.server) {
    return;
  }

  watch(user, user => {
    if (user) {
      startInfopid();
      return;
    }

    clearInfopid();
  });

  onMounted(() => {
    if (user.value) {
      startInfopid();
    }
  });
};
